export const UPDATE_SEARCH_RESULT = 'SEARCH/UPDATE_SEARCH_RESULT';
export const UPDATE_FILTER = 'SEARCH/UPDATE_FILTER';
